import { EXTEND_TRIAL_COOKIE_DAYS_EXPIRE_DEFAULT, EXTEND_TRIAL_COOKIE_KEY } from "constants/cookies";
import { setCookie } from "services/cookies-service";
export const saveExtendTrialCookie = (extendTrialCookie = {})=>{
    extendTrialCookie.token && setCookie(EXTEND_TRIAL_COOKIE_KEY, extendTrialCookie.token, {
        expires: parseInt(extendTrialCookie.daysToExpire) || EXTEND_TRIAL_COOKIE_DAYS_EXPIRE_DEFAULT
    });
};
